import { EXTERNAL } from '../../../../../../constants/fulfillment-types';
import { emptyObject } from 'ui-components/default-props/empty';
import { useEntitiesFulfillmentPlan } from '../../../../../../hooks/entities/selectors/fulfillment-plans';
import { useEntitiesFulfillment } from '../../../../../../hooks/entities/selectors/fulfillments';
import { useEntitiesReturn } from '../../../../../../hooks/entities/selectors/returns';
import { useCurrentUserId, useUserHasShipmentViewRestriction, useUserHasShippingRole } from '../../../../../../hooks/use-user-setting';

const isCopyTrackingEnabled = (isUserAllowed, isShipped, isVoided, isExternalFulfillment) => {
  return isUserAllowed && (isShipped || !isExternalFulfillment) && !isVoided;
};

const useIsCopyTrackingEnabledForUser = (assignedToUserId) => {
  const currentUserId = useCurrentUserId();
  const hasShippingRestriction = useUserHasShipmentViewRestriction();
  const hasShippingRole = useUserHasShippingRole();

  const isNotAssignedToCurrentUser = currentUserId !== assignedToUserId;
  const userHasPermissions = !hasShippingRestriction && hasShippingRole;
  return userHasPermissions && isNotAssignedToCurrentUser;
};

export const useIsCopyTrackingEnabledForFulfillment = (fulfillmentId) => {
  const { fulfillmentPlanId, isLabelVoided, externalFulfillment, shipDateTime } = useEntitiesFulfillment(fulfillmentId) || emptyObject;

  const { assignedToUserId, orderGridStatus, fulfillmentType } = useEntitiesFulfillmentPlan(fulfillmentPlanId) || {};

  const canUserInteractWithFulfillment = useIsCopyTrackingEnabledForUser(assignedToUserId);

  const isFulfillmentVoided = isLabelVoided || externalFulfillment?.isVoided;
  const isExternalFulfillment = fulfillmentType === EXTERNAL;
  const isShippedStatus = orderGridStatus === 'Shipped';
  const isShipped = !!shipDateTime || isShippedStatus;

  return isCopyTrackingEnabled(canUserInteractWithFulfillment, isShipped, isFulfillmentVoided, isExternalFulfillment);
};

export const useIsCopyTrackingEnabledForReturn = (returnFulfillmentId) => {
  const { voidedDateTime, assignedToUserId } = useEntitiesReturn(returnFulfillmentId) || emptyObject;
  const canUserInteractWithReturn = useIsCopyTrackingEnabledForUser(assignedToUserId);

  const isVoided = !!voidedDateTime;

  return isCopyTrackingEnabled(canUserInteractWithReturn, true, isVoided, false);
};
